import axios from 'axios'
import swal from '../plugins/sweetalert'
import { useLoadingStore } from '../stores/loading'
import { config } from './config'

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000
})

axiosInstance.interceptors.request.use(
  (c) => {
    const loadingStore = useLoadingStore()
    loadingStore.showLoading()
    return c
  },
  (error) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    const code = response.data.code
    const data = response.data.data
    if (code == '0000') {
      if (process.env.NODE_ENV === 'development') {
        console.log(data)
      }
      return data
    } else {
      let title = ''
      let icon = ''
      if (code === '0001') {
        title = '系統訊息'
        icon = 'success'
      } else if (code === '0002') {
        title = '系統訊息'
        icon = 'warning'
      } else if (code === '9999') {
        title = '系統異常錯誤'
        icon = 'error'
        console.error(data)
      } else {
        title = '不知名錯誤'
        icon = 'error'
        console.error(data)
      }
      swal({
        title: title,
        html: data,
        icon: icon,
        showCancelButton: false,
        confirmButtonText: '確定'
      })
    }
    return null
  },
  (error) => {
    const loadingStore = useLoadingStore()
    loadingStore.hideLoading()
    return Promise.reject(error)
  }
)

export default axiosInstance
